import { Baby } from "lucide-react";

export const GREETING_DEFAULTS = {
  background: "/greeting-bg.jpg",
  showPhoto: true,
  bismillah: "Bismillahirrahmanirrahim",
  intro: "Alhamdulillah hari ini, kami dapat melaksanakan tasyakuran aqiqah anak kami yang bernama :",
  doa: "Semoga menjadi anak yang sholeh/sholehah, taat kepada Allah Subhanahu Wa Ta'ala dan berbakti kepada kedua orang tua. Aamiin Ya Rabbal 'Alamin",
};

export const GREET_BG_OPTIONS = [
  { id: "none", label: "Polos", url: null },
  { id: "anak", label: "Anak", url: "/greeting-bg.jpg" },
  { id: "dewasa", label: "Dewasa", url: "/greeting-bg-dewasa.jpg" },
  { id: "meninggal", label: "Almarhum/ah", url: "/greeting-bg-meninggal.jpg" },
];

export function GreetingCardOne({ cfg, data }) {
  const { background, showPhoto = true, bismillah, intro, doa } = cfg;
  const childName = data.childName || "Ananda Fulan";
  const father = data.father || "";
  const mother = data.mother || "";
  const noBgStyle = background ? {} : { boxShadow: "0 0 0 2px #C9A24B inset, 0 0 0 6px #ffffff inset, 0 0 0 7px #E7D8B5 inset" };

  return (
    <div className="relative flex overflow-hidden bg-white" style={{ width: "533px", height: "377px", ...noBgStyle }}>
      {background && (
        <img src={background} alt="" className="pointer-events-none absolute inset-0 h-full w-full" style={{ objectFit: "fill" }} crossOrigin="anonymous" />
      )}

      <div className="relative z-10 flex h-full w-full items-start px-6 pt-12">
        {showPhoto && (
          <div className="flex w-[33%] shrink-0 justify-center pl-3 pt-4">
            {data.photoUrl ? (
              <img src={data.photoUrl} alt={childName} className="h-[128px] w-[128px] rounded-full object-cover" style={{ boxShadow: "0 8px 20px rgba(0,0,0,0.22)" }} crossOrigin="anonymous" />
            ) : (
              <div className="flex h-[128px] w-[128px] items-center justify-center rounded-full bg-[#F4F0EA]" style={{ boxShadow: "0 8px 20px rgba(0,0,0,0.18)" }}>
                <Baby className="h-12 w-12 text-brand-gold" />
              </div>
            )}
          </div>
        )}

        <div className={`flex flex-col items-center pt-1 text-center ${showPhoto ? "flex-1" : "w-full"}`} style={{ color: "#3a3330" }}>
          <p className="font-serif text-[15px] font-bold italic text-[#1a1a1a]">{bismillah}</p>
          <p className="mt-2 font-serif text-[13px] leading-snug">{intro}</p>
          <p className="my-2 font-sans text-[19px] font-extrabold uppercase tracking-wide text-[#2e7d32] underline decoration-1 underline-offset-4">{childName}</p>
          <p className="font-serif text-[13px] leading-snug">{doa}</p>
          <div className="mt-3 font-serif text-[14px] leading-tight">
            <p>Keluarga Bapak {father || "-"}</p>
            <p>&amp;</p>
            <p>Ibu {mother || "-"}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function GreetingSheet({ id, cfg, data }) {
  return (
    <div id={id} className="bg-white" style={{ width: "1123px", height: "794px", padding: "14px", fontFamily: "Manrope, sans-serif" }}>
      <div className="grid grid-cols-2 grid-rows-2 gap-3">
        {[0, 1, 2, 3].map((i) => (
          <GreetingCardOne key={i} cfg={cfg} data={data} />
        ))}
      </div>
    </div>
  );
}
